import dayjs from 'dayjs';

const parseLastSeen = time => {
  const days = dayjs().diff(dayjs(time), 'days');
  const minutes = dayjs().diff(dayjs(time), 'minutes');

  if (!time) {
    return "";
  };
  return days > 0 ? `${days} days ago` : `${Math.floor(minutes/60)}:${minutes%60 >= 10 ? minutes%60 : `0${minutes%60}`} hours ago`;
};

export default parseLastSeen;